import { SVGProps } from 'react';

const Facebook = ({
  props,
  fill = 'currentColor',
  size = 24,
}: {
  props?: SVGProps<SVGSVGElement>;
  fill?: string;
  size?: string | number;
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fill={fill}
      d="M13.25 8A1.75 1.75 0 0 1 15 6.25h2.25v-2.5H15A4.25 4.25 0 0 0 10.75 8v2a.75.75 0 0 1-.75.75H7.75v2.5H10a.75.75 0 0 1 .75.75v6.25h2.5V14a.75.75 0 0 1 .75-.75h2.415l.625-2.5H14a.75.75 0 0 1-.75-.75V8Zm1.5 1.25H18a.75.75 0 0 1 .727.932l-1 4a.75.75 0 0 1-.727.568h-2.25V21a.75.75 0 0 1-.75.75h-4a.75.75 0 0 1-.75-.75v-6.25H7a.75.75 0 0 1-.75-.75v-4A.75.75 0 0 1 7 9.25h2.25V8A5.75 5.75 0 0 1 15 2.25h3a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-.75.75h-3a.25.25 0 0 0-.25.25v1.25Z"
    />
  </svg>
);

export default Facebook;
